/** SenderType on a job chat line: 1 staff, 2 vendor, 3 system (matches RFIJobOps JobChatMessage). */
export const JOB_CHAT_SENDER_STAFF = 1;
export const JOB_CHAT_SENDER_VENDOR = 2;
export const JOB_CHAT_SENDER_SYSTEM = 3;

export interface JobChatMessage {
  jobChatMessageKey: string;
  jobKey: string;
  senderType: number;
  senderKey: string;
  vendorKey: string | null;
  senderName: string;
  body: string;
  createdUtc: string;
  /** For the vendor's own (outgoing) lines: has staff's read cursor advanced past this message? */
  seenByRecipient: boolean;
  seenByRecipientUtc: string | null;
}

export interface JobChatMessagesData {
  items: JobChatMessage[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  unreadCount: number;
}

/** Mirrors `ApiResponse<T>` from RFIJobOps. */
export interface JobChatApiResponse<T> {
  status: boolean;
  responseCode: number;
  message: string;
  data: T | null;
  details?: unknown[];
  unixTime?: number;
  traceId?: string;
}

export type JobChatMessagesApiResponse = JobChatApiResponse<JobChatMessagesData>;
export type JobChatSendApiResponse = JobChatApiResponse<JobChatMessage>;

/** Result of parsing a job chat API envelope (e.g. success vs. business-rule message). */
export type JobChatMessagesGetResult =
  | { outcome: 'success'; data: JobChatMessagesData }
  | { outcome: 'apiMessage'; message: string; responseCode: number }
  | { outcome: 'failure' };

export type JobChatSendResult =
  | { outcome: 'success'; data: JobChatMessage }
  | { outcome: 'apiMessage'; message: string; responseCode: number }
  | { outcome: 'failure' };
